import { Link } from '@coop/components';
import { ExternalLinkIcon } from '@coop/icons';

const EnergyLabelProductSheetLink = ({
    productSheetUrl,
    label = 'Produktinformationsblad',
}: {
    productSheetUrl: string | undefined;
    label?: string;
}) => {
    if (!productSheetUrl) {
        return null;
    }

    return (
        <Link
            href={productSheetUrl}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            icon={<ExternalLinkIcon />}
            aria-label={`${label}, Öppnas i nytt fönster.`}
            onClick={(e) => e.stopPropagation()}
        >
            {label}
        </Link>
    );
};

export default EnergyLabelProductSheetLink;
